import classNames from 'classnames'
import React from 'react';
import { MESSAGES } from '../../constants/constants';
import './Message.css';

export const Message=(props)=>{
    const {text,type}=props?.message||{};
    let messageStyle;
    switch(type){
        case MESSAGES.ERROR:
            messageStyle='error';
            break
        case MESSAGES.SUCCESS:
            messageStyle='success';
            break;
        case MESSAGES.INFO:
            messageStyle='info'
            break;
        default:
            messageStyle=''
    }
    return((text||props.children) && <div className={classNames('xs-regular message mgb-12',messageStyle,props.className)}>{text}
    {props.children && props.children}
    </div>)
}